package com.tovtalk.utils.strings

internal var _currentAppLanguage: String = "he"

fun setAppLanguageForStrings(lang: String) {
    _currentAppLanguage = if (lang.isNotBlank()) lang else "he"
}

/** All user-facing strings come from API (TranslationsStore). No local fallback maps. */
actual object StringProvider {
    actual fun get(key: String): String {
        val value = TranslationsStore.get(key) ?: key

        return value
    }

    actual fun get(key: String, vararg formatArgs: Any): String {
        val template = get(key)
        if (formatArgs.isEmpty()) return template
        return template.replace(Regex("%(\\d+)\\$[sd]")) { match ->
            val index = match.groupValues[1].toIntOrNull() ?: return@replace match.value
            if (index in 1..formatArgs.size) formatArgs[index - 1].toString() else match.value
        }.replace("%s", formatArgs.getOrNull(0)?.toString() ?: "")
    }
}
